var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4.5,
    stroke: "#A9ACB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L7.7161 11.7143C7.48996 11.4939 7.30982 11.2283 7.18668 10.9335C7.06354 10.6387 7 10.321 7 10C7 9.679 7.06354 9.36126 7.18668 9.06649C7.30982 8.77171 7.48996 8.50609 7.7161 8.28571L12 4",
    stroke: "#A9ACB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveLeft);
export default __webpack_public_path__ + "static/media/InActive-Left.ee312c880dc24b2951689c912379f676.svg";
export { ForwardRef as ReactComponent };